"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowRegItemsStateDto = exports.EventRegItemStateDto = exports.EventRegApproveTypeDto = exports.EventRegStateDto = void 0;
var EventRegStateDto;
(function (EventRegStateDto) {
    EventRegStateDto["DISABLED"] = "disabled";
    EventRegStateDto["DRAFT"] = "draft";
    EventRegStateDto["ENABLED"] = "enabled";
})(EventRegStateDto = exports.EventRegStateDto || (exports.EventRegStateDto = {}));
var EventRegApproveTypeDto;
(function (EventRegApproveTypeDto) {
    EventRegApproveTypeDto["AUTO"] = "auto";
    EventRegApproveTypeDto["MANUAL"] = "manual";
})(EventRegApproveTypeDto = exports.EventRegApproveTypeDto || (exports.EventRegApproveTypeDto = {}));
var EventRegItemStateDto;
(function (EventRegItemStateDto) {
    EventRegItemStateDto["SUBMITTED"] = "submitted";
    EventRegItemStateDto["CONFIRMED"] = "confirmed";
})(EventRegItemStateDto = exports.EventRegItemStateDto || (exports.EventRegItemStateDto = {}));
var ShowRegItemsStateDto;
(function (ShowRegItemsStateDto) {
    ShowRegItemsStateDto["DISABLED"] = "disabled";
    ShowRegItemsStateDto["DRAFT"] = "draft";
    ShowRegItemsStateDto["ENABLED"] = "enabled";
})(ShowRegItemsStateDto = exports.ShowRegItemsStateDto || (exports.ShowRegItemsStateDto = {}));
